<template>
  <div class="green-bloc">
    <div class="green-bloc-header">
      <h3 >{{category.name}}</h3>
    </div>
    <div class="green-bloc-body">
      <table class="mytable">
        <tbody v-show="!isSaving">
          <tr v-for="item in modelCopy.items" :key="item.id" :class="{inactive : !item.isValid}">
            <td>{{item.question}}<input type="hidden" :value="item.id" /></td>
            <td>
              <i v-if="!editMode" class='material-icons'>{{getCheckStateClass(item.answer)}}</i>
              <select v-else v-model="item.answer">
                <option v-bind:value="null" disabled>?</option>
                <option v-bind:value="true">{{$resx('YesText')}}</option>
                <option v-bind:value="false">{{$resx('NoText')}}</option>
              </select>
            </td>
          </tr>
        </tbody>
        <tfoot v-show="isSaving">
          <tr>
            <td colspan="2" class="text-center">
              <i class="loading material-icons">cached</i>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="green-bloc-footer">
      <button v-show="!editMode" class="btn btn-secondary" @click="editMode=true">{{$resx('EditText')}}</button>
      <button v-show="editMode" class="btn btn-secondary" @click="editMode=false">{{$resx('CancelText')}}</button>
      <button v-show="editMode" style="margin-left:.5em" class="btn btn-primary" @click="save" :disabled="isSaving">{{$resx('SaveText')}}</button>
    </div>
  </div>
</template>
<script>
import GreenCategoryItem from '../../models/green/categoryItem'
import greenServices from '../../services/greenServices'

export default {
  props: {
    category: null
  },
  data () {
    return {
      isSaving: false,
      editMode: false,
      modelCopy: null
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    }
  },
  watch: {
    editMode: function (val) {
      if (val) {
        this.modelCopy = this.copyFullObject(this.category)
      }
    }
  },
  methods:
  {
    // Copie de l'objet référence dans une autre variable
    copyFullObject: function (source) {
      var newObj = {
        id: source.id,
        name: source.name,
        items: []
      }
      source.items.forEach(function (element) {
        newObj.items.push(new GreenCategoryItem(element))
      })
      return newObj
    },

    // retourne l'icone pour indiquer le statut d'un item
    getCheckStateClass: function (value) {
      if (value === null) {
        return 'priority_high'
      } else {
        return value ? 'check' : 'close'
      }
    },

    // sauvegarde des éléments
    async save () {
      this.isSaving = true
      try {
        await greenServices.updateAnswers(this.currentCampingId, this.modelCopy.items)
        this.$emit('update-category', this.copyFullObject(this.modelCopy))
        this.$store.commit('app/showSnack', { type: 'success', message: 'Catégorie "' + this.category.name + '" mise à jour avec succès !' })
        this.editMode = false
      } catch (error) {
        this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
      } finally {
        this.isSaving = false
      }
    }
  },
  created: function () {
    this.modelCopy = this.copyFullObject(this.category)
  }
}
</script>
